p,
h1,
h2 {
  margin: 0;
}

wm-header {
  margin-bottom: 0.5rem;
}

.container {
  font-family: var(--font-family);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  background: var(--background);
  color: var(--text-color);
}

h2 {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.625rem;
  text-align: center;
  color: var(--heading-color);
}

.steps {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  gap: 2rem;
}

.steps li {
  padding-bottom: 2rem;
  border-bottom: 1px solid;
  border-color: var(--text-color, #363636);
}

.steps .step-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.steps .button {
  appearance: none;
  text-decoration: none;
  border: none;

  margin-top: var(--Paddings-sm);
  display: flex;
  justify-content: center;
  padding: var(--Paddings-sm);
  border-radius: var(--Radius-Moderate-rounding);

  background: var(--accent-color);
  color: white;
  color: contrast-color(var(--accent-color));
}

.step-icon {
  padding: 0.35rem;
  color: var(--accent-color);
}

.step-icon svg {
  width: 1.65rem;
  height: 1.65rem;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.semi-bold {
  font-weight: 500;
}

.footer p {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer a {
  text-decoration: underline;
  color: var(--accent-color);
}

.footer img {
  height: 1.5rem;
}

/* Close button */
button {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-color);
  padding: var(--Paddings-sm);

  &:hover,
  &:focus {
    color: var(--heading-color);
    transform: scale(1.1);
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
}

@media (max-width: 480px) {
  .container {
    gap: 1.25rem;
  }

  .steps {
    gap: 1.25rem;
  }
}
